<template>
    <el-dialog
        title="预约对局"
        :visible.sync="YyDialogVisible"
        width="300px"
        :center="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :before-close="() => CloseYyDialog()"
        v-loading.fullscreen.lock="login_loading"
    >
        <el-form
            :model="YuYue"
            ref="YuYueForm"
            label-width="100px"
        >
            <div style="font-size: 20px;">想几点开始玩？</div>
            <div>
                <el-time-select
                    size="small"
                    align="center"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="YuYue.start_time"
                    :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '23:30'
                    }"
                >
                </el-time-select>
            </div>
            <br />
            <div style="font-size: 20px;">能接受的最晚时间？</div>
            <div>
                <el-time-select
                    size="small"
                    align="center"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    v-model="YuYue.end_time"
                    :picker-options="{
                        start: '00:00',
                        step: '00:30',
                        end: '23:30',
                        minTime: YuYue.start_time
                    }"
                >
                </el-time-select>
            </div>
        </el-form>
        <div slot="footer">
            <el-button type="primary" plain @click="SubmitYuYue()">确 定</el-button>
            <el-button plain @click="CloseYyDialog()">取 消</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { AddYuYueRequest } from '@/network/user.js'

export default {
    name: 'YyDialogComponent',
    data() {
        return {
            login_loading: false,
            YuYue: {
                start_time: '',
                end_time: ''
            }
        }
    },
    computed: {},
    methods: {
        CloseYyDialog() {
            this.YuYue = {
                start_time: '',
                end_time: ''
            }
            this.$emit('ExiYyDialog')
        },
        SubmitYuYue() {
            this.login_loading = true
            AddYuYueRequest(this.YuYue)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('预约成功!')
                        this.CloseYyDialog()
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    filters: {},
    props: {
        YyDialogVisible: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
}
</script>

<style lang='less'></style>